import React from 'react'
import { FormControl, Select, MenuItem, Checkbox, ListItemText, Chip } from '@material-ui/core'
import { Close } from '@material-ui/icons'

type Option = {
  value: string
  label: string
}

interface MultiSelectCheckboxProps {
  label: string
  options: Option[]
  selectedValues: string[]
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void
  onDelete: (value: string) => void
}

const MultiSelectCheckbox: React.FC<MultiSelectCheckboxProps> = ({
  label,
  options,
  selectedValues,
  onChange,
  onDelete,
}) => {
  const getLabel = (value: string, options: Option[]) => {
    for (const item of options) if (value == item.value) return item.label
    return null
  }

  return (
    <div className="dialog-section">
      <p className="font-weight-bold subtitle">{label}</p>
      <FormControl fullWidth>
        <Select
          multiple
          value={selectedValues}
          onChange={onChange}
          renderValue={() =>
            selectedValues
              .filter((val) => getLabel(val, options) != null)
              .map((val) => (
                <Chip
                  key={val}
                  label={getLabel(val, options)}
                  color="primary"
                  style={{ color: 'white' }}
                  deleteIcon={<Close style={{ color: 'white' }} />}
                  onDelete={() => onDelete(val)}
                />
              ))
          }
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <Checkbox color="primary" readOnly checked={selectedValues.includes(opt.value)} />
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default MultiSelectCheckbox



// WEBPACK FOOTER //
// ./src/components/CompanyInfo/MultiSelectCheckbox.tsx